/* eslint-disable */
enum HomePageEvents {

    // -----------------------------------------------------------------------------------
    //おすすめビデオ
    // 取得
    GetRecVideoListStarted = "[HomePageEvents] GetRecVideoListStarted",
    GetRecVideoListComplete = "[HomePageEvents] GetRecVideoListComplete",
    // TODO
    ResetRecVideos　= "[HomePageEvents] ResetRecVideos",
    GetEditRecVideoListStarted = "[HomePageEvents] GetEditRecVideoListStarted",
    GetEditRecVideoListComplete = "[HomePageEvents] GetEditRecVideoListComplete",
    // 編集
    UpdateRecVideosStarted = "[HomePageEvents] UpdateRecVideosStarted",
    UpdateRecVideosComplete = "[HomePageEvents] UpdateRecVideosComplete",
    UpdateRecVideosFailed = "[HomePageEvents] UpdateRecVideosFailed",
    // 追加
    AddVideoToRecStarted = "[HomePageEvents] AddVideoToRecStarted",
    AddVideoToRecComplete = "[HomePageEvents] AddVideoToRecComplete",
    // 削除

    // -----------------------------------------------------------------------------------
    //おすすめプログラム
    // 取得
    GetRecommendProgramListStarted = "[HomePageEvents] GetRecommendProgramListStarted",
    GetRecommendProgramListComplete = "[HomePageEvents] GetRecommendProgramListComplete",
    // 編集
    UpdateRecProgramsStarted = "[HomePageEvents] UpdateRecProgramsStarted",
    UpdateRecProgramsComplete = "[HomePageEvents] UpdateRecProgramsComplete",
    UpdateRecProgramsFailed = "[HomePageEvents] UpdateRecProgramsFailed",
    // 追加
    addRecProgramStarted = "[HomePageEvents] addRecProgramStarted",
    addRecProgramComplete = "[HomePageEvents] addRecProgramComplete",
    // 削除
    delRecProgramStarted = "[HomePageEvents] delRecProgramStarted",
    delRecProgramComplete = "[HomePageEvents] delRecProgramComplete",

    // -----------------------------------------------------------------------------------
    //おすすめプロフェショナル
    // 取得
    GetRecommendProfessionalListStarted = "[HomePageEvents] GetRecommendProfessionalListStarted",
    GetRecommendProfessionalListComplete = "[HomePageEvents] GetRecommendProfessionalListComplete",
    // 編集
    UpdateRecProfessionalsStarted = "[HomePageEvents] UpdateRecProfessionalsStarted",
    UpdateRecProfessionalsComplete = "[HomePageEvents] UpdateRecProfessionalsComplete",
    UpdateRecProfessionalsFailed = "[HomePageEvents] UpdateRecProfessionalsFailed",
    // 追加
    addRecProfessionalStarted = "[Presenters] addRecProfessionalStarted",
    addRecProfessionalComplete = "[Presenters] addRecProfessionalComplete",
    // 削除
    removeRecProfessionalStarted = "[Presenters] removeRecProfessionalStarted",
    removeRecProfessionalComplete = "[Presenters] removeRecProfessionalComplete",

    // -----------------------------------------------------------------------------------
    // 新着ビデオ
    // 取得
    GetNewVideoListStarted = "[HomePageEvents] GetNewVideoListStarted",
    GetNewVideoListComplete = "[HomePageEvents] GetNewVideoListComplete",

    // -----------------------------------------------------------------------------------
    // ユーザー視聴履歴
    GetVideoListByUserStarted = "[HomePageEvents] GetVideoListByUserStarted",
    GetVideoListByUserComplete = "[HomePageEvents] GetVideoListByUserComplete",
    ResetUserVideos = "[HomePageEvents] ResetUserVideos"

}

export default HomePageEvents;
